import React from 'react';
import styled from 'styled-components';
import { AppButton } from '../buttons';
import { FlexContainer } from '../styled-ui';

const StyledAccordionHeader = styled(FlexContainer)<{
  isSubHeader?: boolean;
  hasDescription?: boolean;
}>`
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  h2 {
    font-size: ${({ isSubHeader }) =>
      isSubHeader
        ? 'var(--semi-big-font-size)'
        : 'var(--heading-small-font-size)'};
    line-height: ${({ isSubHeader }) =>
      isSubHeader
        ? 'var(--semi-big-line-height)'
        : 'var(--heading-small-line-height)'};
    font-weight: 700;
    margin: 0;
    padding-bottom: ${({ hasDescription }) =>
      hasDescription ? 'var(--xsmall-padding)' : '0'};
  }

  p {
    font-size: var(--small-font-size);
    line-height: var(--small-line-height);
    margin: 0;
  }
`;

type AccordionTabHeaderProps = {
  title?: string;
  titleComponent?: React.ReactNode;
  description?: string;
  isSubHeader?: boolean;
  children?: React.ReactNode;
  buttonLabel?: string;
  buttonOnClick?: () => void;
};

export const AccordionTabHeader = ({
  title,
  titleComponent,
  description,
  isSubHeader = false,
  children,
  buttonLabel,
  buttonOnClick,
}: AccordionTabHeaderProps) => {
  if (!title && !titleComponent && !description && isSubHeader) {
    return null;
  }

  return (
    <>
      <StyledAccordionHeader
        isSubHeader={isSubHeader}
        hasDescription={!!description}
      >
        <FlexContainer
          direction="column"
          align="flex-start"
          justify="flex-start"
        >
          {titleComponent ? titleComponent : <h2 className="mb-0">{title}</h2>}
          {description && <p className="mb-0">{description}</p>}
        </FlexContainer>
        {buttonLabel && buttonOnClick && (
          <AppButton
            label={buttonLabel}
            onClick={buttonOnClick}
            type="outlined"
            severity="no-background"
          />
        )}
      </StyledAccordionHeader>
      {children && <div className="flex-shrink-0">{children}</div>}
    </>
  );
};
